import { PasswordService } from "@/services";
import { mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  name: "security-password",
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      repeatPassword: "",
      passwordModal: false,
      showPrevPassword: false,
      showNewPassword: false,
      showRepeatPassword: false,
      validationRegex: [],
      matchedCase: [],
      validationMessage: "",
      regexErrors: [],
      isFocused: false,
      isBlurred: false,
      isRequesting: false,
      errorText: "",
      oldError: false,
      newError: false,
      repeatError: false
    };
  },
  computed: {
    isPasswordValid() {
      let counter = 0;
      this.matchedCase.forEach(el => {
        if (el.status === "checked") {
          counter++;
        }
      });
      return counter === this.matchedCase.length;
    }
  },
  mounted() {
    this.getPasswordRegex();
  },
  methods: {
    ...mapActions({
      setValidationRegex: types.auth.actions.ACTION_VALIDATION_REGEX
    }),
    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    },

    openPasswordModal() {
      this.passwordModal = true;
    },

    closePasswordModal() {
      this.passwordModal = false;
    },

    checkEmptiness() {
      this.oldError = false;
      this.newError = false;
      this.repeatError = false;

      if (!this.oldPassword) {
        this.oldError = true;
      }

      if (!this.newPassword) {
        this.newError = true;
      }

      if (!this.repeatPassword) {
        this.repeatError = true;
      }
    },

    updatePassword() {
      this.checkEmptiness();
      const { oldPassword, newPassword, repeatPassword } = this;
      if (
        oldPassword &&
        newPassword &&
        repeatPassword &&
        this.isPasswordValid
      ) {
        PasswordService.update(oldPassword, newPassword, repeatPassword)
          .then(res => {
            this.passwordModal = false;
            this.$toast.success(res.data.message);
            this.oldPassword = "";
            this.newPassword = "";
            this.repeatPassword = "";
          })
          .finally(() => {
            this.finishRequest();
          });
        this.startRequest();
      }
    },
    getPasswordRegex() {
      PasswordService.passwordRegex()
        .then(response => {
          this.validationRegex = response.data.data;
        })
        .then(() => {
          this.validationRegex.forEach(elem => {
            let regex = elem.regex;
            regex = regex.substring(1, regex.length - 1);
            this.matchedCase.push({
              message: elem.message,
              type: elem.type,
              regex: regex,
              status: "default"
            });
          });
          // this.setValidationRegex(this.matchedCase);
        });
    },
    validatePassword(value) {
      this.regexErrors = [];
      this.matchedCase.forEach(elem => {
        if (value.match(elem.regex)) {
          if (this.isFocused) {
            elem.status = "checked";
          }
          this.regexErrors.push(elem);
        } else {
          if (this.isBlurred) {
            elem.status = "unchecked";
          } else if (this.isFocused) {
            elem.status = "default";
          }
          this.regexErrors.push(elem);
        }
      });
    },
    reInitValidation(event) {
      if (event.type === "focus") {
        this.isFocused = true;
        this.regexErrors = [...this.matchedCase];
      } else if (event.type === "blur") {
        this.isBlurred = true;
        this.validatePassword(this.newPassword);
      }
    }
  }
};
